import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="bg-offwhite py-20 md:py-28" data-id="element-125">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-127">
          <p className="text-2xl md:text-3xl font-body font-semibold text-navy-dark leading-relaxed mb-8" data-id="element-128">
            Tú trabajas duro por tu dinero. Pero cuando llega la temporada de
            impuestos, parece que todos quieren una parte de tu reembolso.
          </p>
          <p className="text-lg md:text-xl font-body text-gray-700 leading-relaxed mb-8" data-id="element-129">
            Los preparadores en la calle te cobran $200 por una declaración
            "simple". Los programas de internet te prometen que es "gratis",
            pero te cobran $120 en el último segundo solo porque trabajas por tu
            cuenta o tienes deducciones básicas.
          </p>
          <div className="inline-block bg-navy-light text-white px-8 py-6 rounded-lg shadow-xl border-l-4 border-gold-accent" data-id="element-130">
            <p className="text-xl md:text-2xl font-bold font-heading uppercase tracking-wide" data-id="element-131">
              Es tu dinero. ¿Por qué pagarle a un intermediario para decirle al
              gobierno que lo ganaste?
            </p>
            <p className="mt-2 text-gold-accent font-semibold text-lg" data-id="element-132">
              La Guía de Libertad Fiscal es tu salida de la industria de
              impuestos de alto costo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}